export default "__VITE_ASSET__B6H9F182__"